// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import ImportSourcesModal from './ImportSourcesModal';
import { HotKeys } from 'react-hotkeys';


class ImportSourcesButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      importSourcesSelectorVisible: false
    };
    this.toggleimportSourcesSelector = this.toggleimportSourcesSelector.bind(this);
  }

  toggleimportSourcesSelector() {
    this.setState({ importSourcesSelectorVisible: !this.state.importSourcesSelectorVisible });
  }

  render() {
    const {
      dsa,
      modalOpen,
      onClick,
      onDismissModal,
      onSubmitImport,
      onDownloadTemplates,
      importResults,
      importErrors,
      importing
    } = this.props;

    const { importSourcesSelectorVisible } = this.state;
    let sourcesButton = null;

    if (importSourcesSelectorVisible) {
      sourcesButton = (<span className='import-sources-button'>
        <Button
          onClick={onClick}
          label='Import'
        />
        <ImportSourcesModal
          dsaType={dsa.dsaType}
          open={modalOpen}
          onDismiss={onDismissModal}
          onSubmitImport={onSubmitImport}
          onDownloadTemplates={onDownloadTemplates}
          importResults={importResults}
          importErrors={importErrors}
          importing={importing}
        />
      </span>);
    }

    return (
      <HotKeys
        keyMap={{ 'toggleimportSourcesSelector': 'ctrl+shift+h' }}
        handlers={{ 'toggleimportSourcesSelector': this.toggleimportSourcesSelector }}
        focused
        attach={window}
        style={{outline: 0}}
      >
        { sourcesButton }
      </HotKeys>
    );
  }
}

ImportSourcesButton.propTypes = {
  dsa: PropTypes.object.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onDismissModal: PropTypes.func.isRequired,
  onSubmitImport: PropTypes.func.isRequired,
  onDownloadTemplates: PropTypes.func.isRequired,
  importResults: PropTypes.object.isRequired,
  importErrors: PropTypes.array.isRequired,
  importing: PropTypes.bool.isRequired
};

export default ImportSourcesButton;



// WEBPACK FOOTER //
// ./src/components/sources/ImportSourcesButton.js